module.exports = __webpack_public_path__ + "img/facebook.840c9d73.svg";